import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.bubble.css";

const Description = ({ data }) => {
  if (!data?.description) return null;

  return (
    <Paper
      elevation={1}
      sx={{
        p: 3,
        borderRadius: 2,
        backgroundColor: "#fff",
      }}
    >
      <Typography
        variant="h6"
        sx={{ fontWeight: 600, mb: 2 }}
      >
        More About This Property
      </Typography>

       <ReactQuill
  value={data?.description}
  readOnly
  theme="bubble"
/>
    </Paper>
  );
};

export default Description;
